import { render } from "./PlanetariumGame.vue?vue&type=template&id=8794a9c4&scoped=true"
import script from "./PlanetariumGame.vue?vue&type=script&lang=js"
export * from "./PlanetariumGame.vue?vue&type=script&lang=js"

import "./PlanetariumGame.vue?vue&type=style&index=0&id=8794a9c4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8794a9c4"]])

export default __exports__